import React from "react";

import Reports from "./content";

const ReportsPage = ({ inside = false }) => {
	return <Reports inside={inside} />;
};

export default ReportsPage;
